import { Container } from "pixi.js"
import { Snake } from "./snake"
import { DemonFish } from "./demon-fish"
import { Squid } from "./squid"
import { EvilStarfish } from "./evil-starfish"
import { MamaSquid } from "./mama-squid"
export async function Monsters({ player, isSolid, projectiles }) {
  const monsters = new Container()

  const tick = (time) => {
    monsters.children.forEach((monster) => {
      monster.tick(time)

      for (let i = 0; i < projectiles.children.length; ++i) {
        const projectile = projectiles.children[i]

        if (
          Math.abs(projectile.velocity.x) < 5 &&
          Math.abs(projectile.velocity.y) < 5
        )
          continue

        monster.checkBullet(projectile, time)
      }

      if (monster.health <= 0) {
        monsters.removeChild(monster)

        ++player.xp
        if (player.xp >= player.level) player.levelUp()
      }
    })
  }

  const onTileGenerated = async ({ x, y, width, height }) => {
    const getSpawnRate = (offset) =>
      Math.min(Math.max((y - offset) / 3000, 0), 8)

    const monstersToSpawn = {
      snakes: Math.round(getSpawnRate(1) * Math.floor(Math.random() * 3 + 1)),
      demonFish: Math.round(
        getSpawnRate(1600) * Math.floor(Math.random() * 2 + 1),
      ),
      squid: Math.round(getSpawnRate(5400) * Math.floor(Math.random() * 2)),
      evilStarfish: Math.round(
        getSpawnRate(6200) * Math.floor(Math.random() * 2 + 1),
      ),
      mamaSquid: Math.round(getSpawnRate(7800) * Math.floor(Math.random() * 2)),
    }

    const totalToSpawn = Object.values(monstersToSpawn).reduce(
      (sum, value) => sum + value,
      0,
    )

    const spawnPoints = findSpawnPoints({
      count: totalToSpawn,
      x,
      y,
      width,
      height,
      isSolid,
    })

    await Promise.all(
      [
        [Snake, monstersToSpawn.snakes],
        [DemonFish, monstersToSpawn.demonFish],
        [Squid, monstersToSpawn.squid],
        [EvilStarfish, monstersToSpawn.evilStarfish],
        [MamaSquid, monstersToSpawn.mamaSquid],
      ].map(async ([Monster, count]) => {
        for (let i = 0; i < count; ++i) {
          const spawnPoint = spawnPoints.shift()
          const monster = await Monster({
            player,
            isSolid,
            x: spawnPoint.x,
            y: spawnPoint.y,
          })
          monsters.addChild(monster)
        }
      }),
    )
  }

  const onTileRemoved = ({ x, y, width, height }) => {
    const toRemove = monsters.children.filter(
      (m) => m.x >= x && m.x <= x + width && m.y >= y && m.y <= y + height,
    )

    if (toRemove.length) {
      monsters.removeChild(...toRemove)
      console.log(`Removed ${toRemove.length} monsters`)
    }
  }

  return {
    monsters,
    tick,
    onTileGenerated,
    onTileRemoved,
  }
}

const MAX_ATTEMPTS = 1000
function findSpawnPoints({ count, x, y, width, height, isSolid }) {
  const spawnPoints = []

  for (let i = 0; i < MAX_ATTEMPTS; ++i) {
    const spawnPoint = {
      x: Math.round(x + Math.random() * width),
      y: Math.round(y + Math.random() * height),
    }

    if (!isSolid(spawnPoint)) spawnPoints.push(spawnPoint)

    if (spawnPoints.length >= count) break
  }

  return spawnPoints
}
